import * as React from 'react';
import { toTimeString, ToTimeStringOptions } from '../../utils/dateUtil';

export interface TimeFormatterProps {
  amount: number | undefined | null;
  inputUnit?: ToTimeStringOptions['inputUnit'];
  format?: ToTimeStringOptions['format'];
  fallback?: string;
}

export const TimeFormatter: React.FC<TimeFormatterProps> = ({
  amount,
  inputUnit = 'second',
  format = '0h 0m',
  fallback = '-'
}) => {
  if (typeof amount === 'undefined' || amount === null) {
    return fallback;
  }
  return <>{toTimeString(amount, { format, inputUnit })}</>;
};
